import { axiosInstance } from '@/api/axiosInstance';
import { IUnitModel } from './unitModels';

export default async function apiUnitGetAll(): Promise<IUnitModel[]> {
    return await axiosInstance.get('/v1/units');
}